import { render, staticRenderFns } from "./orderhistory.vue?vue&type=template&id=15e9969e&scoped=true&"
import script from "./orderhistory.vue?vue&type=script&lang=js&"
export * from "./orderhistory.vue?vue&type=script&lang=js&"
import style0 from "./orderhistory.vue?vue&type=style&index=0&id=15e9969e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e9969e",
  null
  
)

export default component.exports